import { GlobalError } from "./GlobalError"

export class AppError extends GlobalError {
  keyReason: string
  options: ErrorOptions

  constructor(keyReason: string, message: string, options?: ErrorOptions) {
    super("app-error", message)
    this.keyReason = keyReason
    this.options = options || {}
  }
}
